import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Bouncy.scss';
const Bouncy = ({ size = 45, color = 'black', speed = 1.75, }) => {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
        }, children: _jsxs("div", { className: styles.inner, children: [_jsx("div", { className: styles.cube, children: _jsx("div", { className: styles.cube__inner }) }), _jsx("div", { className: styles.cube, children: _jsx("div", { className: styles.cube__inner }) }), _jsx("div", { className: styles.cube, children: _jsx("div", { className: styles.cube__inner }) })] }) }));
};
export default Bouncy;
